// extracted by mini-css-extract-plugin
export default {"heading__Body":"Heading_heading__Body__DLXBV","heading__row":"Heading_heading__row__c1STf","heading":"Heading_heading__CGbG6","heading__action":"Heading_heading__action__KobJ4"};